import { ENOPCaseStatus } from '../../enums';

export const NEW_CASE_STATUSES = [
  ENOPCaseStatus.Accepted,
  ENOPCaseStatus.PendingLogistics,
  ENOPCaseStatus.ClinicalScreening,
];
